module.exports = __webpack_public_path__ + "static/media/not-found-img2.ac3ab5d3.png";